import z from 'zod'
import { AsyncFn } from '../../common'
import { guidSchema } from '../../contracts'
import { ForCompany } from '../Company/Company'
import { UserGuid } from '../Users/User'

export const ApiKeyJwtPayloadSchema = z.object({
  version: z.string(),
  emailAddress: z.string(),
  companyGuid: guidSchema,
  userGuid: guidSchema,
})

export type ApiKey = string & {
  readonly __apiKey: 'ApiKey'
}

export type ApiKeyJwtPayload = z.infer<typeof ApiKeyJwtPayloadSchema>

export type ApiKeyPayload = ForCompany<{
  userGuid: UserGuid
  emailAddress: string
}>

export type ApiKeyGenerator = AsyncFn<ApiKeyPayload, ApiKey>

export type ApiKeyValidator = AsyncFn<string | ApiKey, ApiKeyPayload>
